import { useLazyQuery } from "@apollo/client";
import { GET_ALL_TEAM_MEMBERS_QUERY } from "../queries/query.team.list";

const useTeamMembers = () => {
  // Query for getting teamMembers
  const [
    _getAllTeamMembers,
    {
      loading: isfetchingTeamMembers,
      data: teamMembers,
      error: fetchingTeamMembersError,
    },
  ] = useLazyQuery(GET_ALL_TEAM_MEMBERS_QUERY, {
    fetchPolicy: "no-cache",
    nextFetchPolicy: "no-cache",
  });

  const getAllTeamMembers = (id) => {
    _getAllTeamMembers({
      variables: {
        orgId: id,
      },
    });
  };

  // Methods and Properties from hook
  return {
    fetchingTeamMembersError,
    getAllTeamMembers,
    allTeamMembers: teamMembers?.getAllTeamMembers,
    isfetchingTeamMembers,
  };
};

export default useTeamMembers;
